/* eslint-disable react-hooks/exhaustive-deps */
import { Callout } from "@blueprintjs/core"
import { ID, IPost } from "@libs/interfaces/layouts"
import { Pagi } from "@libs/useful"
import { LoaderMinimal } from "@libs/useful/Loading"
import { __ } from "@libs/utilities"
import React, { CSSProperties, Fragment, useEffect, useMemo, useState } from "react"
import Moment from "react-moment"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { IState, useMainStore } from "../../../../settings/zustand"
import actions from "../../data/actions"
import { GET_FEED_ACTION } from '../../data/actionTypes'
import { useDataStore } from "../../data/store"
import FeedComponent from "./FeedComponent"
import FeedContainer from "./FeedContainer"
import FeedLayout from "./FeedLayout"
  
export interface IFeedParams {
  seed?: any
  tick?: any
  col?: number
  pageCount?: number
  [key: string]: any
}
export interface IPagiStyle {
  labelStyle?: CSSProperties,
  className?: string
  fulCountWidth?: number
  containerClassName?: string
  isHideNumerics?:boolean
}
export interface IFeedProps {
  layoutComponent? : any
  setFooter?: (item: any ) => JSX.Element
  component?: any
  data_type: string
  is_hide_pagi?: boolean
  setOffset?: (offset: number) => void
  offset?: number
  count?: number
  height?: number
  paging?: string
  land_id?: ID
  class_name?: string
  containerClassName?: string
  containerStyle? : React.CSSProperties
  style?: React.CSSProperties
  params?: IFeedParams
  topPagiHide?: boolean
  isLoader?: boolean
  bottomPagiHide?: boolean, 
  order?: any
  filter?: ID[]
  isEmptyComment?: string
  feedBefore?: any[]
  onLoading?: (items: any[],  offset: number, count: number, paging: string, fullCount: number) => void
  items? : any[] 
  topPagingWidget?: JSX.Element
  bottomPagingWidget?: JSX.Element
  isDateRaze?: boolean
  dateRazeClassName?: string
  includeFields?: string,
  pagiLabelStyle?: IPagiStyle
}

const Feed = (props: IFeedProps) => {

  const numberposts: number = useMainStore( ( state: IState ) => state.pageCount )
  const pageCount = props.params?.pageCount || numberposts
  //const [items, setItems] = useState<any[]>( props.items || [] )
  const items : any[] = useDataStore( (state: any) => state[props.data_type]) || props.items || [] 
  const [fullCount, setFullCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>( true )
  const [offset, setOffset] = useState<number>( props.offset || 0) 
  const addBefore = (): any[] => {
    if( Array.isArray(props.feedBefore) ) {
      return props.feedBefore
    }
    return []
  }

  useEffect(() => {
    if(Array.isArray( props.items ) ) {
      //setItems( props.items )
    }
  }, [props.items] )

  const onComponentUpdate = () => {
    setIsLoading(true)  
    switchFeed( 0 )
  }
  const feed: JSX.Element = useMemo( () => {
    const FeedElementComponent = props.component ? props.component : FeedComponent
    let feedItems : any[] = [...items || []].filter(item => !!item) 
    const mainFeedItems: IPost[] =  [
      ...addBefore(), 
      ...(
        Array.isArray( props.filter )
          ?
          feedItems.filter( item => !props.filter?.includes( item.id ) )
          :
          feedItems
      )
    ] 
    const getDateFormat = (item : IPost) : string => { 
      const day =  new Date(Number(item.post_date || "0") * 1000).getDay()
      const yesterday = new Date().getDay() - 1
      const now = new Date().getDay() 
      return day === now
        ?
        `${__("today")}` 
          :
          day === yesterday
          ?
          `${__("yesterday")}` 
          :
          "D MMMM YYYY"
    }
    return Array.isArray(mainFeedItems) && mainFeedItems.length > 0 
      ?
      <>        
        { 
          mainFeedItems
          .filter((item, i) => i < pageCount)
          .map(( item: IPost, i: number ) => {
            const element: JSX.Element = <FeedElementComponent 
              item={item} 
              i={i}
              data_type={ props.data_type }
              params={ props.params }
              height={ props.height }  
              footer={ props.setFooter? props.setFooter( item ) : null}
              onUpdate={onComponentUpdate}
            />
            const key = item.id + "_" + i
            return (!!props.isDateRaze && i > 0 && new Date(Number(item.post_date || "0") * 1000).getDay() !== new Date(Number(feedItems[i-1].post_date || "0") * 1000).getDay())
            // || ( !!props.isDateRaze && i === 0)
              ?
              <Fragment key={key}>
                <div className={ props.dateRazeClassName || "mt-2 small" }>
                  <Moment 
                    locale="ru" 
                    format={ getDateFormat( item ) }
                  >
                    { Number( item.post_date || "0" ) * 1000 }
                  </Moment>
                </div>
                { element }
              </Fragment>
              :            
              <Fragment key={key}>{element}</Fragment>
          })
        } 
      </>
      :
      <FeedContainer>
        <CalloutNoExists message={props.isEmptyComment} /> 
      </FeedContainer>
      
    }, 
    [ 
      items, 
      offset, 
      props.params,
      props.params?.tick,
      props.component,
      props.containerClassName, 
      props.height 
    ]
  ) 
  
  const switchFeed = ( newOffset: number ) => {
    // console.log( "offset:", newOffset, "land_id:", props.land_id )
    if(!props.data_type) return
    actions(
      GET_FEED_ACTION, 
      { 
        data_type: props.data_type, 
        offset: newOffset, 
        count: pageCount, 
        paging: (props.paging || "") + " " + (props.order || "") || "",
        includeFields: props.includeFields,
        land_id: props.land_id
      })
          .then(resp => {
            const items : any[] = [ ...addBefore(), ...resp.feed] 
            
            // второе условие -- костыль для DataTableView
            if(props.onLoading && !!items.length) { 
              props.onLoading( items, newOffset, pageCount, props.paging || "", resp.count )
            }
            setFullCount(resp.count)
            setIsLoading(false) 
          })
  } 
  useEffect(() => {
    setOffset( 0 )
    setFullCount( 0 )
    //setItems( [] )
  }, [ props.data_type ])
 
  useEffect(() => {
    setIsLoading(true) 
  }, [ props.data_type ])

  useEffect(() => {
    setIsLoading(true)  
    switchFeed( offset || 0 )
  }, [  props.paging, props.land_id, props.data_type, props.order, props.params?.seed, props.params?.tick ])

  useEffect(() => {
    setIsLoading(true)
    switchFeed( offset || 0 )
  }, [ ])
 
  useEffect(() => { 
    setOffset( props.offset || 0 )
    //console.log("OFFSET", props.offset, offset)
    switchFeed( props.offset || 0)
  }, [ props.offset ]) 
  
  if (!props.data_type && !props.items?.length) {
    return <Callout>
      {__("Unknown data type")}
    </Callout>
  }  
  const getShifter = (obj:IPagiStyle={}): JSX.Element | null =>
  { 
    return pageCount && pageCount < fullCount && !props.is_hide_pagi
        ?
          <div className={`py-1 d-flex pe-pagi  flex-md-row flex-column ${obj.className ? obj.className : ""}`} >
            {
              !obj.isHideNumerics && <div className="my-auto">
                <span className="bg-secondary px-2 py-1 text-light" style={{width: obj.fulCountWidth}}>
                  {fullCount}
                </span>
              </div>
            }            
            <Pagi
              all={Math.ceil(fullCount / pageCount) - 1}
              current={Number( offset ) / pageCount}
              onChoose={ onPagi }  
              marginPagesDisplayed={ 4 }
              {...obj}
            />
            {}
          </div>
        : 
        !obj.isHideNumerics 
          ?
          <div className="my-auto">
            <span className="bg-secondary px-2 py-1 m-1 text-light">
              {fullCount}
            </span>
          </div>
          :
          null
  }
  const onPagi = ( n: number ): void => {
    setIsLoading( true )
    const newOffset: number = n * pageCount
    setOffset( newOffset )  
    switchFeed( newOffset )
    if( props.setOffset ) {
      props.setOffset( newOffset )
    }
  }

  
  return <div className={`${props.containerClassName || ""} ${isLoading ? "opacity_75" : ""} mb-5 `} style={props.containerStyle} data-testid="feed-cont">
    <div className="d-md-flex justify-content-between align-items-center " data-testid="feed-top-paging"> 
      {
        !props.topPagiHide && <div className="my-3 w-100">{ getShifter(props.pagiLabelStyle) }</div>
      }
      {
        props.isLoader && isLoading && 
          <LoaderMinimal style={{ height: 14, display:"flex" }} />
      }
      { props.topPagingWidget }
    </div>
    <div className="w-100">
      <div></div>
      <div className={`w-100 flex-grow-100 ${props.class_name}`}  style={ props.style } data-testid="feed-feedLayout-cont">
        <FeedLayout {...props} isLoading={isLoading}>
          {feed}
        </FeedLayout> 
      </div>        
      <div className="mobile-pagination-container small" >
        <div style={{ position:"fixed", bottom: 110, right:0, backgroundColor: "#44444499", width:32 }}>
          { getShifter({ containerClassName:"pagination-vertical text-light", isHideNumerics: true, fulCountWidth: 36, className: "overflow-hidden" }) }  
        </div>
      </div>
    </div>
    <div className="d-md-flex d-none justify-content-between align-items-center" data-testid="feed-bottom-paging"> 
      {
        !props.bottomPagiHide && <div className="my-3 w-100">{ getShifter(props.pagiLabelStyle) }</div>
      } 
    </div>
    { props.bottomPagingWidget }
  </div> 
}
 
export default Feed